import { REMOVE_MESSAGE } from '../redux-action-types';

export default id => ({
  id,
  type: REMOVE_MESSAGE
});



// WEBPACK FOOTER //
// ./src/app/action-creators/remove-message.js